import {Component, OnInit} from '@angular/core';
import {FooterDataService} from "../../components/footer/footer-data.service";
import {Router} from "@angular/router";
import {BusyService} from "../../services/busy.service";

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss']
})
export class UnsubscribeComponent implements OnInit {
  error = null;
  constructor(
    private service: FooterDataService,
    private router: Router,
    private busy: BusyService
  ) {
  }

  ngOnInit(): void {
  }

  onSubmit() {
    this.error = null;
    this.busy.setState(true);
    this.service.cancelSubscription()
    .subscribe(() => {
      this.busy.setState(false);

      return this.router.navigate([]);
    }, () => {
      this.error = 'Something goes wrong. Please try later';

      this.busy.setState(false);
    })
  }

}
